<template>
  <button
    class="btn btn-secondary p-2"
    @click="getMyLocation"
    data-toggle="tooltip"
    style="box-sizing: border-box"
    title="Use my location"
  >
    <img
      alt="My location"
      src="@/assets/icons/Solid_ColourIcons_1024px-31.svg"
      style="width:15px; height:15px"
    >
  </button>
</template>
<script>
import EventBus from '@/eventBus';

export default {
  methods: {
    getMyLocation() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.myLocation = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
        EventBus.$emit('coordinateSet', this.myLocation);
      });
    },
  },
  data() {
    return {
      myLocation: {
        latitude: null,
        longitude: null,
      },
    };
  },
  name: 'ByMyLocation',
};
</script>
